import * as React from 'react';
import type { SVGProps } from 'react';
const IconMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconMinus"
    role="presentation"
    {...props}
  >
    <path fill="currentColor" d="M19 11H5v2h14z" />
  </svg>
);
export default IconMinus;
